import { AxiosError } from 'axios'
import Vue from 'vue'

import BaseTemplateHandledApiError from './exceptions/BaseTemplateHandledApiError'

function handle401(): void {
  Vue.prototype.$templateRouter.replace({ name: 'login' })
}

export default function axiosErrorHandler(error: AxiosError): any  {
  if (error?.response?.status === 401) {
    handle401()

    throw new BaseTemplateHandledApiError(error, (error.response.data as {
      message: string
    }).message)
  }

  throw error
}
